import script from "./VariableSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./VariableSelector.vue?vue&type=script&setup=true&lang=js"

import "./VariableSelector.vue?vue&type=style&index=0&id=289d0c3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-289d0c3c"]])

export default __exports__